import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from "../base-custom-dialog";
import { ActionIconHelper } from "../../../../helper/action-icon.helper";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ACTION_DATA_SERVICE, ActionDataService } from "../../../../services/action/data.service";
import { ICompanyContacts, IContact } from '../../../../models/leads/leads.model';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../services/leads/leads-data.service';

@Component({
  selector: 'fi-compendium-deny-popup',
  templateUrl: './compendium-deny-popup.component.html',
  styleUrls: ['./compendium-deny-popup.component.scss'],
  standalone: false,
})
export class CompendiumDenyPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('COMPENDIUM_DENY', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('COMPENDIUM_DENY', true);
  submitting: boolean;
  companyContacts: ICompanyContacts[];
  contactToDisplay: IContact;
  inValidNote = false;

  constructor(
    public dialogRef: MatDialogRef<CompendiumDenyPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      contactName: string,
      leadId: number,
      leadTypeId: number,
      title: string
    },
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;

    this.leadsDataService.getLeadById(this.leadId).subscribe(( { success, data } ) => {
      if ( success ) {
        this.companyContacts = data.CompanyContacts;
        this.contactToDisplay = data.Contact;
      }
    });
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.leadId && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if ( this.formIsValid ) {
      this.submitting = true;
      this.actionDataService.compendiumDeny(this.leadId, this.note).subscribe(( { success, data } ) => {
        if ( success ) {
          this.clearClassAndCloseDialog(this.dialogRef, 'remove');
        }

        this.submitting = false;
      });
    }
  }
}
